export const treeData = {
  "All Trees": {
    layerURL: "",
    scientificName: "",
    treeAtlasURL: "",
    usdaPlantDbURL: "",
    photoName: "5484226-PPT.jpg",
    photoCredit:
      "USDA Forest Service - Southern Research Station, USDA Forest Service, SRS, Bugwood.org",
  },
  ailanthus: {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Other/MapServer/175",
    scientificName: "Ailanthus",
    treeAtlasURL: "https://www.fs.usda.gov/nrs/atlas/tree/341",
    usdaPlantDbURL:
      "https://plants.sc.egov.usda.gov/home/plantProfile?symbol=AILAN",
    photoName: "1150028-PPT.jpg",
    photoCredit: "Chuck Bargeron, University of Georgia, Bugwood.org",
  },
  "Alaskan yellow-cedar": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Cypress/MapServer/1",
    scientificName: "Callitropsis nootkatensis",
    treeAtlasURL: "",
    usdaPlantDbURL:
      "https://plants.sc.egov.usda.gov/home/plantProfile?symbol=CANO9",
    photoName: "2652006-PPT.jpg",
    photoCredit: "Paul E. Hennon, USDA Forest Service, Bugwood.org",
  },
  "alder spp.": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Alder/MapServer/1",
    scientificName: "Alnus",
    treeAtlasURL: "",
    usdaPlantDbURL:
      "https://plants.sc.egov.usda.gov/home/plantProfile?symbol=ALNUS",
    photoName: "5472381-PPT.jpg",
    photoCredit: "Rob Routledge, Sault College, Bugwood.org",
  },
  "American basswood": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Other/MapServer/1",
    scientificName: "Tilia americana",
    treeAtlasURL: "https://www.fs.usda.gov/nrs/atlas/tree/951",
    usdaPlantDbURL: "https://plants.sc.egov.usda.gov/plant-profile/TIAM",
    photoName: "0008298-PPT.jpg",
    photoCredit: "Paul Wray, Iowa State University, Bugwood.org",
  },
  "American beech": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Other/MapServer/7",
    scientificName: "Fagus grandifolia",
    treeAtlasURL: "https://www.fs.usda.gov/nrs/atlas/tree/531",
    usdaPlantDbURL:
      "https://plants.sc.egov.usda.gov/home/plantProfile?symbol=FAGR ",
    photoName: "5445846-PPT.jpg",
    photoCredit: "Rob Routledge, Sault College, Bugwood.org",
  },
  "American hornbeam": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Other/MapServer/25",
    scientificName: "Carpinus caroliniana",
    treeAtlasURL: "https://www.fs.usda.gov/nrs/atlas/tree/391",
    usdaPlantDbURL: "https://plants.sc.egov.usda.gov/plant-profile/CACA18",
    photoName: "5497695-PPT.jpg",
    photoCredit: "T. Davis Sydnor, The Ohio State University, Bugwood.org",
  },
  "American sycamore": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Sycamore/MapServer/1",
    scientificName: "Platanus occidentalis",
    treeAtlasURL: "https://www.fs.usda.gov/nrs/atlas/tree/731",
    usdaPlantDbURL: "https://plants.sc.egov.usda.gov/plant-profile/PLOC",
    photoName: "1480338-PPT.jpg",
    photoCredit: "Richard Webb, Bugwood.org",
  },
  "Arizona cypress": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Cypress/MapServer/7",
    scientificName: "Hesperocyparis arizonica",
    treeAtlasURL: "",
    usdaPlantDbURL: "https://plants.sc.egov.usda.gov/plant-profile/HEAR22",
    photoName: "cugl9_001_php.jpg",
    photoCredit:
      "J.S. Peterson. Australia, New South Wales, Sydney, Royal Botanic Gardens",
  },
  "Arizona sycamore": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Sycamore/MapServer/7",
    scientificName: "Platanus wrightii",
    treeAtlasURL: "",
    usdaPlantDbURL: "https://plants.sc.egov.usda.gov/plant-profile/PLWR2",
    photoName: "5393531-PPT.jpg",
    photoCredit: "Whitney Cranshaw, Colorado State University, Bugwood.org",
  },
  "ash spp.": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Ash/MapServer/1",
    scientificName: "Fraxinus",
    treeAtlasURL: "",
    usdaPlantDbURL:
      "https://plants.sc.egov.usda.gov/home/plantProfile?symbol=FRAXI",
    photoName: "5022066-PPT.jpg",
    photoCredit:
      "Pennsylvania Department of Conservation and Natural Resources - Forestry , Bugwood.org",
  },
  "Atlantic white-cedar": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Cypress/MapServer/13",
    scientificName: "Chamaecyparis thyoides",
    treeAtlasURL: "https://www.fs.usda.gov/nrs/atlas/tree/43",
    usdaPlantDbURL: "https://plants.sc.egov.usda.gov/plant-profile/CHTH2",
    photoName: "5472685-PPT.jpg",
    photoCredit: "Karan A. Rawlins, University of Georgia, Bugwood.org",
  },
  "bald cypress": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Cypress/MapServer/25",
    scientificName: "Taxodium distichum",
    treeAtlasURL: "https://www.fs.usda.gov/nrs/atlas/tree/221",
    usdaPlantDbURL:
      "https://plants.sc.egov.usda.gov/home/plantProfile?symbol=TADI2",
    photoName: "5583570-PPT.jpg",
    photoCredit: "James R. Holland, Bugwood.org",
  },
  "bigcone Douglas-fir": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/DouglasFir/MapServer/1",
    scientificName: "Pseudotsuga macrocarpa",
    treeAtlasURL: "",
    usdaPlantDbURL:
      "https://plants.sc.egov.usda.gov/home/plantProfile?symbol=PSMA",
    photoName: "",
    photoCredit: "",
  },
  "birch spp.": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Birch/MapServer/1",
    scientificName: "Betula",
    treeAtlasURL: "",
    usdaPlantDbURL:
      "https://plants.sc.egov.usda.gov/home/plantProfile?symbol=BETUL",
    photoName: "1480061-PPT.jpg",
    photoCredit: "Richard Webb, Bugwood.org",
  },
  "black locust": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Pea/MapServer/1",
    scientificName: "Robinia pseudoacacia",
    treeAtlasURL: "https://www.fs.usda.gov/nrs/atlas/tree/901",
    usdaPlantDbURL: "https://plants.sc.egov.usda.gov/plant-profile/ROPS",
    photoName: "1480440-PPT.jpg",
    photoCredit: "Richard Webb, Bugwood.org",
  },
  "black spruce": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Spruce/MapServer/5",
    scientificName: "Picea mariana",
    treeAtlasURL: "https://www.fs.usda.gov/nrs/atlas/tree/95",
    usdaPlantDbURL:
      "https://plants.sc.egov.usda.gov/home/plantProfile?symbol=PIMA",
    photoName: "5472356-PPT.jpg",
    photoCredit: "Rob Routledge, Sault College, Bugwood.org",
  },
  blackgum: {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Gum/MapServer/1",
    scientificName: "Nyssa sylvatica",
    treeAtlasURL: "https://www.fs.usda.gov/nrs/atlas/tree/693",
    usdaPlantDbURL: "https://plants.sc.egov.usda.gov/plant-profile/NYSY",
    photoName: "2119007-PPT.jpg",
    photoCredit: "Chris Evans, University of Illinois, Bugwood.org",
  },
  "blackwood acacia": {
    layerURL: "",
    scientificName: "Acacia melanoxylon",
    treeAtlasURL: "",
    usdaPlantDbURL: "https://plants.sc.egov.usda.gov/plant-profile/ACME",
    photoName: "5558788-PPT.jpg",
    photoCredit: "Juan Campá, MGAP, Bugwood.org",
  },
  "cabbage palmetto": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Other/MapServer/49",
    scientificName: "Sabal palmetto",
    treeAtlasURL: "https://www.fs.usda.gov/nrs/atlas/tree/912",
    usdaPlantDbURL: "https://plants.sc.egov.usda.gov/plant-profile/SAPA",
    photoName: "5491222-PPT.jpg",
    photoCredit:
      "Patti Anderson, Identifying Commonly Cultivated Palms, USDA APHIS PPQ, Bugwood.org",
  },
  "California sycamore": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Sycamore/MapServer/13",
    scientificName: "Platanus racemosa",
    treeAtlasURL: "",
    usdaPlantDbURL: "https://plants.sc.egov.usda.gov/plant-profile/PLRA",
    photoName: "1611399-PPT.jpg",
    photoCredit: "John Ruter, University of Georgia, Bugwood.org",
  },
  "cherry and plum spp.": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Cherry/MapServer/1",
    scientificName: "Prunus",
    treeAtlasURL: "",
    usdaPlantDbURL:
      "https://plants.sc.egov.usda.gov/home/plantProfile?symbol=PRUNU",
    photoName: "1611824-PPT.jpg",
    photoCredit: "John Ruter, University of Georgia, Bugwood.org",
  },
  "cottonwood and poplar spp.": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Cottonwood/MapServer/1",
    scientificName: "Populus",
    treeAtlasURL: "",
    usdaPlantDbURL:
      "https://plants.sc.egov.usda.gov/home/plantProfile?symbol=POPUL",
    photoName: "5527566-PPT.jpg",
    photoCredit: "T. Davis Sydnor, The Ohio State University, Bugwood.org",
  },
  "Douglas-fir": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/DouglasFir/MapServer/7",
    scientificName: "Pseudotsuga",
    treeAtlasURL: "",
    usdaPlantDbURL:
      "https://plants.sc.egov.usda.gov/home/plantProfile?symbol=PSEUD7",
    photoName: "0008334-PPT.jpg",
    photoCredit: "Paul Wray, Iowa State University, Bugwood.org",
  },
  "elm spp.": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Elm/MapServer/1",
    scientificName: "Ulmus",
    treeAtlasURL: "",
    usdaPlantDbURL:
      "https://plants.sc.egov.usda.gov/home/plantProfile?symbol=ULMUS",
    photoName: "1480678-PPT.jpg",
    photoCredit: "Richard Webb, Bugwood.org",
  },
  "eucalyptus spp.": {
    layerURL: "", // No corresponding layer
    scientificName: "Eucalyptus",
    treeAtlasURL: "",
    usdaPlantDbURL: "https://plants.sc.egov.usda.gov/plant-profile/EUCAL",
    photoName: "1604384-PPT.jpg",
    photoCredit: "John Ruter, University of Georgia, Bugwood.org",
  },
  "fir spp.": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Fir/MapServer/1",
    scientificName: "Abies",
    treeAtlasURL: "",
    usdaPlantDbURL:
      "https://plants.sc.egov.usda.gov/home/plantProfile?symbol=ABIES",
    photoName: "0008335-PPT.jpg",
    photoCredit: "Paul Wray, Iowa State University, Bugwood.org",
  },
  "hemlock spp.": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Hemlock/MapServer/1",
    scientificName: "Tsuga",
    treeAtlasURL: "",
    usdaPlantDbURL:
      "https://plants.sc.egov.usda.gov/home/plantProfile?symbol=TSUGA",
    photoName: "5488146-PPT.jpg",
    photoCredit: "Rob Routledge, Sault College, Bugwood.org",
  },
  "incense-cedar": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Cypress/MapServer/31",
    scientificName: "Calocedrus decurrens",
    treeAtlasURL: "",
    usdaPlantDbURL: "https://plants.sc.egov.usda.gov/plant-profile/CADE27",
    photoName: "5454011-PPT.jpg",
    photoCredit:
      "Donald Owen, California Department of Forestry and Fire Protection, Bugwood.org",
  },
  "larch spp.": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Larch/MapServer/1",
    scientificName: "Larix",
    treeAtlasURL: "",
    usdaPlantDbURL:
      "https://plants.sc.egov.usda.gov/home/plantProfile?symbol=LARIX",
    photoName: "1643631-PPT.jpg",
    photoCredit:
      "USDA Forest Service - Coeur d'Alene Field Office, Bugwood.org",
  },
  "maple spp.": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Maple/MapServer/1",
    scientificName: "Acer",
    treeAtlasURL: "",
    usdaPlantDbURL:
      "https://plants.sc.egov.usda.gov/home/plantProfile?symbol=ACER",
    photoName: "1749075-PPT.jpg",
    photoCredit: "Robert L. Anderson, USDA Forest Service, Bugwood.org",
  },
  "mixed species": {
    layerURL: "",
    scientificName: "",
    treeAtlasURL: "",
    usdaPlantDbURL: "",
    photoName: "5474242-PPT.jpg",
    photoCredit: "Dan Aamlid, Bugwood.org",
  },
  "Monterey cypress": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Cypress/MapServer/43",
    scientificName: "Hesperocyparis macrocarpa",
    treeAtlasURL: "",
    usdaPlantDbURL: "https://plants.sc.egov.usda.gov/plant-profile/HEMA22",
    photoName: "1603843-PPT.jpg",
    photoCredit: "John Ruter, University of Georgia, Bugwood.org",
  },
  "New Mexico locust": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Pea/MapServer/33",
    scientificName: "Robinia neomexicana",
    treeAtlasURL: "",
    usdaPlantDbURL: "https://plants.sc.egov.usda.gov/plant-profile/RONE",
    photoName: "1208047-PPT.jpg",
    photoCredit: "Dave Powell, USDA Forest Service, Bugwood.org",
  },
  "northern white-cedar": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Cypress/MapServer/43",
    scientificName: "Thuja occidentalis",
    treeAtlasURL: "https://www.fs.usda.gov/nrs/atlas/tree/241",
    usdaPlantDbURL: "https://plants.sc.egov.usda.gov/plant-profile/THOC2",
    photoName: "5454114-PPT.jpg",
    photoCredit: "Rob Routledge, Sault College, Bugwood.org",
  },
  "oak spp.": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Oak/MapServer/1",
    scientificName: "Quercus",
    treeAtlasURL: "",
    usdaPlantDbURL:
      "https://plants.sc.egov.usda.gov/home/plantProfile?symbol=QUERC",
    photoName: "5454705-PPT.jpg",
    photoCredit: "Jason Sharman, Vitalitree, Bugwood.org",
  },
  "ohia spp.": {
    layerURL: "",
    scientificName: "Metrosideros",
    treeAtlasURL: "",
    usdaPlantDbURL:
      "https://plants.sc.egov.usda.gov/home/plantProfile?symbol=METRO",
    photoName: "5390655-PPT.jpg",
    photoCredit: "Forest and Kim Starr, Starr Environmental, Bugwood.org",
  },
  "Pacific madrone": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Other/MapServer/127",
    scientificName: "Arbutus menziesii",
    treeAtlasURL: "",
    usdaPlantDbURL: "https://plants.sc.egov.usda.gov/plant-profile/ARME",
    photoName: "5045045-PPT.jpg",
    photoCredit: "Joseph OBrien, USDA Forest Service, Bugwood.org",
  },
  "paper birch": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Birch/MapServer/11",
    scientificName: "Betula papyrifera",
    treeAtlasURL: "",
    usdaPlantDbURL:
      "https://plants.sc.egov.usda.gov/home/plantProfile?symbol=BEPA ",
    photoName: "5445763-PPT.jpg",
    photoCredit: "David Lee, Bugwood.org",
  },

  "pine spp.": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Pine/MapServer/1",
    scientificName: "Pinus",
    treeAtlasURL: "",
    usdaPlantDbURL:
      "https://plants.sc.egov.usda.gov/home/plantProfile?symbol=PINUS",
    photoName: "5557105-PPT.jpg",
    photoCredit: "Elizabeth McCarty, University of Georgia, Bugwood.org",
  },
  "Port-Orford-cedar": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Cypress/MapServer/55",
    scientificName: "Chamaecyparis lawsoniana",
    treeAtlasURL: "",
    usdaPlantDbURL:
      "https://plants.sc.egov.usda.gov/home/plantProfile?symbol=CHLA",
    photoName: "5517086-PPT.jpg",
    photoCredit:
      "Donald Owen, California Department of Forestry and Fire Protection, Bugwood.org",
  },
  "quaking aspen": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Cottonwood/MapServer/47",
    scientificName: "Populus tremuloides",
    treeAtlasURL: "https://www.fs.usda.gov/nrs/atlas/tree/746",
    usdaPlantDbURL:
      "https://plants.sc.egov.usda.gov/home/plantProfile?symbol=POTR5",
    photoName: "5516335-PPT.jpg",
    photoCredit: "Becca MacDonald, Sault College, Bugwood.org",
  },
  "redcedar/juniper spp.": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Juniper/MapServer/1",
    scientificName: "Juniperus",
    treeAtlasURL: "",
    usdaPlantDbURL:
      "https://plants.sc.egov.usda.gov/home/plantProfile?symbol=JUNIP",
    photoName: "1608464-PPT.jpg",
    photoCredit: "John Ruter, University of Georgia, Bugwood.org",
  },
  redwood: {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Redwood/MapServer/7",
    scientificName: "Sequoia sempervirens",
    treeAtlasURL: "",
    usdaPlantDbURL: "https://plants.sc.egov.usda.gov/plant-profile/SESE3",
    photoName: "5529397-PPT.jpg",
    photoCredit: "David Stephens, Bugwood.org",
  },
  saltcedar: {
    layerURL: "",
    scientificName: "Tamarix ramosissima",
    treeAtlasURL: "",
    usdaPlantDbURL: "https://plants.sc.egov.usda.gov/plant-profile/TARA",
    photoName: "5477185-PPT.jpg",
    photoCredit: "Leslie J. Mehrhoff, University of Connecticut, Bugwood.org",
  },
  sassafras: {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Laurel/MapServer/13",
    scientificName: "Sassafras albidum",
    treeAtlasURL: "https://www.fs.usda.gov/nrs/atlas/tree/931",
    usdaPlantDbURL: "https://plants.sc.egov.usda.gov/plant-profile/SAAL5",
    photoName: "5539412-PPT.jpg",
    photoCredit: "T. Davis Sydnor, The Ohio State University, Bugwood.org",
  },
  "Sitka spruce": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Spruce/MapServer/35",
    scientificName: "Picea sitchensis",
    treeAtlasURL: "",
    usdaPlantDbURL:
      "https://plants.sc.egov.usda.gov/home/plantProfile?symbol=PISI",
    photoName: "5369199-PPT.jpg",
    photoCredit: "Joe Nicholson, Bugwood.org",
  },
  "spruce spp.": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Spruce/MapServer/1",
    scientificName: "Picea",
    treeAtlasURL: "",
    usdaPlantDbURL:
      "https://plants.sc.egov.usda.gov/home/plantProfile?symbol=PICEA",
    photoName: "5349098-PPT.jpg",
    photoCredit: "Keith Kanoti, Maine Forest Service, Bugwood.org",
  },
  sweetgum: {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Other/MapServer/163",
    scientificName: "Liquidambar styraciflua",
    treeAtlasURL: "https://www.fs.usda.gov/nrs/atlas/tree/611",
    usdaPlantDbURL: "https://plants.sc.egov.usda.gov/plant-profile/LIST2",
    photoName: "1480267-PPT.jpg",
    photoCredit: "Richard Webb, Bugwood.org",
  },
  "subalpine fir": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Fir/MapServer/53",
    scientificName: "Abies lasiocarpa",
    treeAtlasURL: "",
    usdaPlantDbURL:
      "https://plants.sc.egov.usda.gov/home/plantProfile?symbol=ABLA",
    photoName: "1210056-PPT.jpg",
    photoCredit: "Dave Powell, USDA Forest Service, Bugwood.org",
  },
  tamarack: {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Larch/MapServer/11",
    scientificName: "Larix laricina",
    treeAtlasURL: "",
    usdaPlantDbURL:
      "https://plants.sc.egov.usda.gov/home/plantProfile?symbol=LALA",
    photoName: "5550231-PPT.jpg",
    photoCredit: "Steven Katovich, Bugwood.org",
  },
  "walnut spp.": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Walnut/MapServer/1",
    scientificName: "Juglans",
    treeAtlasURL: "",
    usdaPlantDbURL:
      "https://plants.sc.egov.usda.gov/home/plantProfile?symbol=JUGLA",
    photoName: "5610770-PPT.jpg",
    photoCredit:
      "Gerald Holmes, Strawberry Center, Cal Poly San Luis Obispo, Bugwood.org",
  },
  "western hemlock": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Hemlock/MapServer/23",
    scientificName: "Tsuga heterophylla",
    treeAtlasURL: "",
    usdaPlantDbURL:
      "https://plants.sc.egov.usda.gov/home/plantProfile?symbol=TSHE",
    photoName: "5471070-PPT.jpg",
    photoCredit:
      "Lyndon Photography, Dried Botanical ID, USDA APHIS PPQ, Bugwood.org",
  },
  "white spruce": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Spruce/MapServer/41",
    scientificName: "Picea glauca",
    treeAtlasURL: "https://www.fs.usda.gov/nrs/atlas/tree/94",
    usdaPlantDbURL:
      "https://plants.sc.egov.usda.gov/home/plantProfile?symbol=PIGL",
    photoName: "5501431-PPT.jpg",
    photoCredit: "Becca MacDonald, Sault College, Bugwood.org",
  },
  "willow spp.": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Willow/MapServer/1",
    scientificName: "Salix",
    treeAtlasURL: "",
    usdaPlantDbURL:
      "https://plants.sc.egov.usda.gov/home/plantProfile?symbol=SALIX",
    photoName: "5539399-PPT.jpg",
    photoCredit: "T. Davis Sydnor, The Ohio State University, Bugwood.org",
  },
  "yellow-poplar": {
    layerURL:
      "https://apps.fs.usda.gov/fsgisx05/rest/services/Hosts/Magnolia/MapServer/31",
    scientificName: "Liriodendron",
    treeAtlasURL: "https://www.fs.usda.gov/nrs/atlas/tree/621",
    usdaPlantDbURL:
      "https://plants.sc.egov.usda.gov/home/plantProfile?symbol=LIRIO",
    photoName: "5471475-PPT.jpg",
    photoCredit: "Karan A. Rawlins, University of Georgia, Bugwood.org",
  },
};
